import React from "react";

import Image from "../common/Image";

import ColorSchema from "../../assets/kits/colors";

interface OrderLabelProps {
  status: number;
}

const OrderLabel: React.FC<OrderLabelProps> = ({ status }) => {
  // console.log("status", status);
  // console.log("status === 0", status === 0);
  // console.log("+status === 0", +status === 0);
  // console.log("--------------------------------------");
  if (+status === 2) {
    return (
      <p
        className="desc-r pd-x-8 pd-y-0"
        style={{
          backgroundColor: ColorSchema.schema_warning_light,
          color: ColorSchema.schema_warning_main,
          borderRadius: 20,
        }}
      >
        در حال تحویل
      </p>
    );
  }
  return (
    <p
      className="desc-r pd-x-8 pd-y-0"
      style={{
        backgroundColor: ColorSchema.schema_positive_light,
        color: ColorSchema.schema_positive_main,
        borderRadius: 20,
      }}
    >
      تحویل شده
    </p>
  );
};

interface ImageSectionProps {
  id: number;
  title: string;
  image_src: string;
  item_count: number;
}

const ImageSection: React.FC<ImageSectionProps> = ({
  id,
  title,
  image_src,
  item_count,
}) => {
  return (
    <div
      className="mr-x-12"
      style={{
        position: "relative",
        minWidth: 32,
        maxWidth: 32,
        minHeight: 32,
        maxHeight: 32,
      }}
    >
      <Image
        style={{
          borderRadius: 6,
          minWidth: 32,
          maxWidth: 32,
          minHeight: 32,
          maxHeight: 32,
        }}
        alt={title}
        src={image_src}
      />
      <div
        className="desc-m"
        style={{
          color: ColorSchema.foreground_surface_me,
          position: "absolute",
          borderRadius: "50%",
          backgroundColor: ColorSchema.schema_surface_light,
          border: `1px solid ${ColorSchema.foreground_outline_darker}`,
          bottom: -2,
          left: -2,
          width: 18,
          height: 18,
          textAlign: "center",
        }}
      >
        {item_count}
      </div>
    </div>
  );
};

export { OrderLabel, ImageSection };
